(function () {
  function initFaq(section) {
    if (!section || section.dataset.auraaFaqReady === 'true') return;
    section.dataset.auraaFaqReady = 'true';

    var items = Array.prototype.slice.call(section.querySelectorAll('[data-auraa-faq-item]'));

    items.forEach(function (item) {
      var toggle = item.querySelector('[data-auraa-faq-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        items.forEach(function (otherItem) {
          if (otherItem === item) return;
          otherItem.classList.remove('is-open');
          var otherToggle = otherItem.querySelector('[data-auraa-faq-toggle]');
          if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        });

        item.classList.toggle('is-open', !isOpen);
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-auraa-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.matches && event.target.matches('[data-auraa-faq]')
      ? event.target
      : event.target.querySelector && event.target.querySelector('[data-auraa-faq]');
    if (section) initFaq(section);
  });
})();